import { api } from "@/lib/api";
import { BaseService } from "./base.service";
import { ApiError, ApiResponse } from "@/interfaces/api.interface";
import { ICompany, ICompanyWithUsers } from "@/interfaces/company.interface";
import { store } from "@/store/store";
import { hideLoader, showLoader } from "@/store/slices/loaderSlice";
import ToastService from "@/utils/toast";

export class CompanyService extends BaseService {
  constructor() {
    super("Company");
  }

  async createCompany(company: ICompany, file: any) {
    try {
      store.dispatch(showLoader());
      // const projId = store.getState().projects.selectedProject?.id;
      // if (!projId || projId === "all") {
      //   ToastService.error("Please select a project");
      //   return;
      // }

      const formData = new FormData();
      formData.append("File", file);
      formData.append("Name", company.name);
      formData.append("Location", company.location || "");
      formData.append("IsMep", company.isMep?.toString() || "false");
      formData.append("IsExternal", company.isExternal?.toString() || "false");
      formData.append("Activities", JSON.stringify(company.activities) || "[]");
      formData.append("Projects", JSON.stringify(company.projects) || "[]");

      const res: any = await api.post(
        `${process.env.REACT_APP_BASE_URL}/api/Company/create-company`,
        formData
      );
      if (res.ok) {
        if (res.data) {
          return { data: res.data, error: null };
        }
        return { data: null, error: res.data };
      }
      return { data: null, error: res.data };
    } catch (error) {
      return { data: null, error: error };
    } finally {
      store.dispatch(hideLoader());
    }
  }

  async uploadImage(companyId: string, file: any) {
    try {
      store.dispatch(showLoader());

      const formData = new FormData();
      formData.append("File", file);
      formData.append("CompanyId", companyId);

      const res: any = await api.post(
        `${process.env.REACT_APP_BASE_URL}/api/Company/upload-image`,
        formData
      );
      if (res.ok) {
        if (res.data) {
          return { data: res.data, error: null };
        }
        return { data: null, error: res.data };
      }
      return { data: null, error: res.data };
    } catch (error) {
      return { data: null, error: error };
    } finally {
      store.dispatch(hideLoader());
    }
  }

  async toggleProjectMembership(
    id: string,
    projectId: string,
    isActive: boolean
  ): Promise<ApiResponse<void>> {
    try {
      store.dispatch(showLoader());
      const res: any = await api.patch(
        `${process.env.REACT_APP_BASE_URL}/api/Company/${id}/project-membership`,
        null,
        { params: { projectId, isActive } }
      );
      return { data: res.data, error: null };
    } catch (error) {
      return { data: null, error: error as ApiError };
    } finally {
      store.dispatch(hideLoader());
    }
  }

  async getWithUsers(
    projectId: string
  ): Promise<ApiResponse<ICompanyWithUsers[]>> {
    try {
      const res = await api.get(
        `${process.env.REACT_APP_BASE_URL}/api/Company/with-users?projectId=${projectId}`
      );

      if (res.ok) {
        return { data: res.data as ICompanyWithUsers[], error: null };
      }

      return { data: null, error: res.data as ApiError };
    } catch (error) {
      return { data: null, error: error as ApiError };
    }
  }
}

export const companySvc = new CompanyService();
